<template>
  <div>
    <van-popup v-model="show" @closed="closed" round :style="{ minWidth: '85%', maxWidth: '90%' }">
      <div class="agreement-popup">
        <!-- 标题 -->
        <div class="popup-header">
          <div class="popup-title">电影购票协议</div>
        </div>
        
        <!-- 协议内容 -->
        <div class="agreement-content">
          <p class="agreement-intro">
            用户点击同意本协议之前，请务必认真阅读、完全理解本协议中全部条款，特别是其中与用户权益有或可能具有重大关系的条款(包括但不限于第1.1条、第1.2条、第1.3条、第2.2条)。当用户按照页面提示阅读、点击确认同意本协议及完成支付购票时，即表示用户已经充分阅读、理解并接受本协议的全部内容。如用户不同意接受本协议的任何条款，或无法理解本协议相关条款含义的，请不要进行后续操作(包括但不限于点击确认或继续使用十节优选平台服务等)。
          </p>
          
          <div class="agreement-section">
            <div class="section-title">1. 购票须知</div>
            <div class="section-item">1.1 请确认场次和时间无误，购买成功后将不可退票、不可改签。</div>
            <div class="section-item">1.2 由于设备故障、片方原因、政策原因等不可抗力因素，存在少量场次取消的情况，平台接到影院通知后，平台会尽快为用户进行退票退款。</div>
            <div class="section-item">1.3 由于影院系统不稳定等因素，导致出票失败的情况，平台会尽快安排退款。</div>
            <div class="section-item">1.4 如发现作弊行为(包括但不限于批量刷单、恶意投诉等)，十节优选平台有权取消该用户后续的退换票购票资格，必要时追究法律责任。</div>
          </div>
          
          <div class="agreement-section">
            <div class="section-title">2. 其他</div>
            <div class="section-item">2.1 用户使用退换服务有任何问题，可随时拨打平台客服电话。如涉及与影院退换规则相关的事项，平台将尽力协助用户与影院进行沟通。</div>
            <div class="section-item">2.2 十节优选平台如根据自身运营和管理需要不定期修订本协议及/或相关服务规则，将提前予以公示，不再向用户单独通知。用户如不接受变更后条款、内容、规则，有权立即停止使用平台服务，用户如继续使用平台服务，则视为接受变更后的条款、内容、规则。请用户注意及时查阅。</div>
          </div>
        </div>
        
        <!-- 勾选框 -->
        <div class="checkbox-wrapper">
          <van-checkbox checked-color="#ee0a24" v-model="check" icon-size="18px">
            <span class="checkbox-text">我已阅读并同意以上协议</span>
          </van-checkbox>
        </div>
        
        <!-- 按钮区域 -->
        <div class="btn-group">
          <div class="btn-primary" :class="{ 'btn-disabled': !check }" @click="goBuy">
            确认购票
          </div>
          <div class="btn-secondary" @click="closed">
            暂不购票
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "GetKnow",
  props: {
    checkT: Boolean
  },
  data() {
    return {
      show: true,
      check: this.checkT
    };
  },
  methods: {
    goBuy() {
      if (!this.check) {
        this.$Toast('请先勾选同意以上协议')
      } else {
        this.$emit("closed", this.check);
      }
    },
    closed() {
      this.$emit("closed", false);
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style lang='scss' scoped>
.agreement-popup {
  background: #fff;
  padding: 1rem;
  padding-bottom: 0.8rem;
}

.popup-header {
  text-align: center;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #f0f0f0;
}

.popup-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

.agreement-content {
  max-height: 18rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.8rem 0;
}

.agreement-intro {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.6;
  text-indent: 2em;
  margin-bottom: 0.8rem;
}

.agreement-section {
  margin-bottom: 0.6rem;
}

.section-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.4rem;
}

.section-item {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0.3rem;
  padding-left: 0.5rem;
}

.checkbox-wrapper {
  padding: 0.8rem 0;
  border-top: 1px solid #f0f0f0;
}

.checkbox-text {
  font-size: 0.9rem;
  color: #333;
}

.btn-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.btn-primary {
  width: 100%;
  height: 2.6rem;
  line-height: 2.6rem;
  text-align: center;
  background: linear-gradient(135deg, #ee0a24 0%, #ff6b4a 100%);
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 2rem;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }
  
  &.btn-disabled {
    background: #ccc;
    cursor: not-allowed;
  }
}

.btn-secondary {
  width: 100%;
  height: 2.6rem;
  line-height: 2.6rem;
  text-align: center;
  background: #f5f5f5;
  color: #666;
  font-size: 1rem;
  border-radius: 2rem;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:active {
    background: #eee;
  }
}
</style>